import React, { useEffect, useState } from "react";
import supabase from "../config/supabaseClient"; // Adjust path if needed
import { MdSearch } from "react-icons/md";
import "./searchbar";

const SearchBar = ({ searchQuery, setSearchQuery, handleSearch }) => {
  const [featuredPhotoUrl, setFeaturedPhotoUrl] = useState(null);
  const [submittedBy, setSubmittedBy] = useState(null);


  // 🔄 Fetch the most recent photo from Supabase on load
  useEffect(() => {
    const fetchPhoto = async () => {
      const { data, error } = await supabase
        .from("weekly_photo")
        .select("image_url, submitted_by_name")
        .eq("is_placeholder", false)
        .order("created_at", { ascending: false })
        .limit(1)
        .single();

      if (error) {
        console.error("Error fetching photo:", error.message);
      } else {
        setFeaturedPhotoUrl(data.image_url);
        setSubmittedBy(data.submitted_by_name);
        // If you want to use non_supa_URL later:
        // setLink(data.non_supa_URL);
      }
    };

    fetchPhoto();
  }, []);

  return (
    <div className="google-layout">
      
      {/* 📸 Featured Image goes here - ABOVE search area */}
      {featuredPhotoUrl && (
        <div className="featured-photo-container">
          <h2 className="featured-title">
            <em>
              Photo of the Week, by member{" "}
              {submittedBy && submittedBy.trim() !== ""
                ? submittedBy
                : "Matheus Bertelli"}
            </em>
          </h2>

          <div className="featured-photo-wrapper">
            <img
              src={featuredPhotoUrl}
              alt="Featured event"
              className="featured-photo"
              loading="lazy"
              onLoad={(e) => e.target.classList.add('loaded')}
            />
          </div>
        </div>
      )}

      {/* 🔍 Search bar section */}
      <div className="search-area">
        <div className="VRC-text">VRC</div>
        <form onSubmit={handleSearch} className="search-wrapper">
          <div className="search-icon"><MdSearch /></div>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </form>
      </div>

      {/* 🧠 Tagline */}
      <div className="Mantra-text">
        Going from pixels to people! Enter your virtual room code and passphrase
      </div>
    </div>
  );
};

export default SearchBar;
